module.exports = __webpack_public_path__ + "static/media/smoking Cessation.0dbe8cb6.svg";